import { render, staticRenderFns } from "./ProductStockReport.vue?vue&type=template&id=20b12764"
import script from "./ProductStockReport.vue?vue&type=script&lang=js"
export * from "./ProductStockReport.vue?vue&type=script&lang=js"
import style0 from "./ProductStockReport.vue?vue&type=style&index=0&id=20b12764&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports